

import { Amplify } from "aws-amplify";
import { Chart, registerables } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { environment } from "./environments/environment";



// Configure Amplify with all modules
Amplify.configure(environment.awsConfig);

// Register chart.js components and annotation plugin
Chart.register(...registerables);
Chart.register(annotationPlugin);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
